<template>
  <AisStats class="FilterResultsCount">
    <template #default="{ nbHits }">
      {{ nbHits }}
    </template>
  </AisStats>
</template>

<style lang="postcss">
.FilterResultsCount {
  font: inherit;
  color: inherit;
}
</style>
